'use client';

import React from 'react';

import { Heading, Body } from '@depop/web-thrift-ui/Typography';
import { LikeIcon } from '@depop/web-ui-kit/Icons/LikeIcon';
import { useParams } from 'next/navigation';
import { useTranslations } from 'next-intl';

import { ShopEmptyState } from '../../../components/EmptyState';

import { ButtonExperiment } from '@/components/ButtonExperiment';
import { ExtendedLink } from '@/components/ExtendedLink';
import { useIsViewingOwnShop } from '@/modules/shop/hooks/useIsViewingOwnShop';

export function LikedProductsEmptyState() {
  const t = useTranslations('shop');
  const isViewingOwnShop = useIsViewingOwnShop();
  const { username } = useParams<{ username: string; locale: string }>();

  return (
    <ShopEmptyState IconComponent={LikeIcon}>
      {isViewingOwnShop ? (
        <>
          <Heading variant="sm" as="p">
            {t('NoLikesOwnProfile', { username })}
          </Heading>
          <Body variant="sm-regular">{t('NoLikesOrSavesSearchPreCta')}</Body>
          <ExtendedLink href="/search/">
            <ButtonExperiment variant="secondary">
              {t('EmptySearchCta')}
            </ButtonExperiment>
          </ExtendedLink>
        </>
      ) : (
        <Body variant="sm-regular">{t('NoLikes', { username })}</Body>
      )}
    </ShopEmptyState>
  );
}
